/* eslint-disbaled no-nested-ternary */
import React, { useState, useEffect } from 'react';

import clsx from 'clsx';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Checkbox,
  Grid,
  Paper,
  makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import store from '../../redux/store';
import * as pricingActionsImport from '../../redux/actions/pricing';
import * as groupsActionsImport from '../../redux/actions/refresh-groups';
import VenueMap from './components/VenueMap';
import CardHeaderComp from './components/CardHeaderComp';
import { VENUE_MAP_MARKETPLACES_CONFIGURATION } from '../../helpers/constants';
import { findSGZone, saveGroupChanges, convertCompsToCompare, validateGroupChanges } from '../../helpers/pricing';
import { updateGroupFields, setPushEnableAction } from '../../redux/actions/refresh-groups';

const styles = makeStyles(() => ({
  pricingSection: {
    marginTop: '8px',
    flexGrow: 1,
    flexBasis: 'auto',
  },
  padding: '0 10px 10px 10px',

  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#9C27B0',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#9C27B0',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#9C27B0',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#9C27B0',
    },
  },
  cardHeaderSection: {
    background: '#F4F4F4',
  },
  cardHeaderSectionDark: {
    background: '#2D3436',
  },
}));

function Seating(props) {
  const { currTNCompSections, groupsMarketplaceComps, isCompAllGroup } = props;
  const [state, setState] = useState({
    seatingSelectionMode: 'section',
  });

  const [zonesColumnSize, setZonesColumnSize] = useState(12);
  const classes = styles();
  const { isCompAllEvent, focusedPricingGroup } = props;

  const handleCompZoneChange = zone => event => {
    const { activeMarketplace, zones, pricingActions, groupsActions } = props;

    const isCompAll = isCompAllEvent || isCompAllGroup;

    if (focusedPricingGroup || !isCompAll) {
      if (!isCompAll) {
        let newComps = null;
        const originalComps = [...currTNCompSections];

        // let finalComps = null;
        const ZoneSectionsFiltered =
          zones && activeMarketplace in zones && zones[activeMarketplace]
            ? zones[activeMarketplace].filter(obj => obj.name === zone)[0]
            : {};
        const foundExistingSectionsInZone = currTNCompSections.findIndex(obj => obj.zone_name === zone);

        const allZoneSectionsNameArray =
          ZoneSectionsFiltered.sections && activeMarketplace === 'seatgeek'
            ? ZoneSectionsFiltered.sections.map(obj => obj.name)
            : [];
        const currCompsZoneSectionsRemoved =
          activeMarketplace === 'ticketnetwork'
            ? currTNCompSections.filter(obj => obj.zone_name !== zone)
            : currTNCompSections.filter(obj => !allZoneSectionsNameArray.includes(obj.canonical_name));
        const allZoneSectionsFormated = ZoneSectionsFiltered.sections.map(obj => ({
          zone_name: zone,
          section_name: obj.name,
          canonical_name: obj.canonical_name,
        }));
        if (typeof event !== 'undefined') {
          newComps = event.target.checked
            ? currCompsZoneSectionsRemoved.concat(allZoneSectionsFormated)
            : currCompsZoneSectionsRemoved;
        } else {
          newComps =
            foundExistingSectionsInZone > -1
              ? currCompsZoneSectionsRemoved
              : currCompsZoneSectionsRemoved.concat(allZoneSectionsFormated);
        }
        pricingActions.setFormTNComparisonData(newComps);
        groupsActions.updateGroupsMarketplaceComps(activeMarketplace, focusedPricingGroup, newComps);

        const compsToCompare = convertCompsToCompare(newComps);
        const objectType = activeMarketplace === 'ticketnetwork' ? 'tnd_sections' : 'sg_sections';
        const initCompsToCompare = convertCompsToCompare(originalComps);
        const enablePush = validateGroupChanges(
          { [objectType]: initCompsToCompare },
          { [objectType]: compsToCompare },
          objectType
        );
        const { newGroupFieldsToUpdate, pushEnableUpdateValue } = saveGroupChanges(
          focusedPricingGroup,
          enablePush,
          store.getState().refreshGroups.isPushEnable,
          'comps',
          store.getState().refreshGroups.groupFields
        );
        if (Object.keys(newGroupFieldsToUpdate).length > 0) {
          store.dispatch(updateGroupFields(newGroupFieldsToUpdate));
        }
        store.dispatch(setPushEnableAction(pushEnableUpdateValue));
      }
    } else {
      alert('Please select a group before adding comps!');
    }
  };

  const handleCompSectionChange = seating => () => {
    const { groupsActions, pricingActions, activeMarketplace, zones } = props;

    if (!focusedPricingGroup) {
      alert('Please select a group before adding comps!');
      return;
    }

    if (!isCompAllGroup) {
      let newComps = [...currTNCompSections];
      const originalComps = [...currTNCompSections];
      const foundIndex = newComps.findIndex(
        obj =>
          (activeMarketplace === 'ticketnetwork' &&
            obj.section_name === seating.section_name &&
            obj.zone_name === seating.zone_name) ||
          (activeMarketplace === 'seatgeek' && obj.section_name.toUpperCase() === seating.section_name.toUpperCase())
      );

      if (foundIndex > -1) {
        newComps = newComps.filter(obj => obj.section_name.toUpperCase() !== seating.section_name.toUpperCase());
      } else {
        const sectionInfo = zones[activeMarketplace]
          .find(currZone => currZone.name === seating.zone_name)
          .sections.find(currSection => currSection.name.toUpperCase() === seating.section_name.toUpperCase());
        newComps.push({ ...seating, canonical_name: sectionInfo.canonical_name });
      }
      pricingActions.setFormTNComparisonData(newComps);
      groupsActions.updateGroupsMarketplaceComps(activeMarketplace, focusedPricingGroup, newComps);

      const compsToCompare = convertCompsToCompare(newComps);
      const objectType = activeMarketplace === 'ticketnetwork' ? 'tnd_sections' : 'sg_sections';
      const initCompsToCompare = convertCompsToCompare(originalComps);
      const enablePush = validateGroupChanges(
        { [objectType]: initCompsToCompare },
        { [objectType]: compsToCompare },
        objectType
      );

      const { newGroupFieldsToUpdate, pushEnableUpdateValue } = saveGroupChanges(
        focusedPricingGroup,
        enablePush,
        store.getState().refreshGroups.isPushEnable,
        'comps',
        store.getState().refreshGroups.groupFields
      );
      if (Object.keys(newGroupFieldsToUpdate).length > 0) {
        store.dispatch(updateGroupFields(newGroupFieldsToUpdate));
      }
      store.dispatch(setPushEnableAction(pushEnableUpdateValue));
    }
  };

  const checkAllBox = _props => {
    const { zone } = _props;
    const { activeMarketplace } = props;
    let numSelected = [];

    if (activeMarketplace === 'ticketnetwork') {
      numSelected =
        groupsMarketplaceComps &&
        groupsMarketplaceComps[activeMarketplace] &&
        groupsMarketplaceComps[activeMarketplace][focusedPricingGroup]
          ? groupsMarketplaceComps[activeMarketplace][focusedPricingGroup].filter(curr => curr.zone_name === zone.name)
          : [];
    } else {
      const sections = zone && zone.sections ? zone.sections.map(curr => curr.name) : [];
      numSelected =
        groupsMarketplaceComps &&
        groupsMarketplaceComps[activeMarketplace] &&
        groupsMarketplaceComps[activeMarketplace][focusedPricingGroup]
          ? groupsMarketplaceComps[activeMarketplace][focusedPricingGroup].filter(curr =>
              sections.includes(curr.canonical_name)
            )
          : [];
    }
    numSelected = numSelected.length;
    const rowCount = zone.sections.length;
    return (
      <Checkbox
        indeterminate={numSelected > 0 && numSelected < rowCount && !isCompAllGroup}
        checked={numSelected === rowCount || isCompAllGroup}
        color="primary"
        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
        onChange={handleCompZoneChange(zone.name)}
        disabled={!focusedPricingGroup || isCompAllGroup}
      />
    );
  };

  const selectionModeChanged = () => {
    const { seatingSelectionMode } = state;
    const toggledSeatingSelectionMode = seatingSelectionMode === 'zone' ? 'section' : 'zone';
    setState({ seatingSelectionMode: toggledSeatingSelectionMode });
  };

  const { zones, venueImages, updateListingsLoading, activeMarketplace } = props;

  const { seatingSelectionMode } = state;
  const marketplaceConfig = VENUE_MAP_MARKETPLACES_CONFIGURATION[activeMarketplace];

  const mapSectionClicked = event => {
    const sectionClicked = event.target.dataset.section;
    const zoneClicked = event.target.dataset.zone;
    if (seatingSelectionMode === 'zone') {
      if (activeMarketplace === 'seatgeek') {
        const zone = findSGZone(zones[activeMarketplace], sectionClicked);
        handleCompZoneChange(zone.name)();
      } else {
        handleCompZoneChange(zoneClicked)();
      }
      return;
    }
    if (activeMarketplace === 'seatgeek') {
      const zone = findSGZone(zones[activeMarketplace], sectionClicked);
      if (zone) {
        handleCompSectionChange({
          zone_name: zone.name,
          section_name: sectionClicked.toUpperCase(),
          zone_type: '',
          low_row: '',
          high_row: '',
        })();
      }
    } else {
      handleCompSectionChange({
        zone_name: zoneClicked,
        section_name: sectionClicked,
        zone_type: '',
        low_row: '',
        high_row: '',
      })();
    }
  };

  const handleCheckboxChange = comps => {
    if (!isCompAllGroup) {
      return currTNCompSections.some(
        seating =>
          (activeMarketplace === 'ticketnetwork' &&
            seating.zone_name === comps.zone_name &&
            seating.section_name === comps.section_name) ||
          (activeMarketplace === 'seatgeek' && seating.section_name.toUpperCase() === comps.section_name.toUpperCase())
      );
    }
    return isCompAllGroup;
  };

  useEffect(() => {
    if (zones && zones[activeMarketplace]) {
      if (zones[activeMarketplace].length > 1) {
        setZonesColumnSize(6);
      } else if (zones[activeMarketplace].length === 1) {
        setZonesColumnSize(12);
      }
    }
  }, [activeMarketplace]);

  return (
    <Card square className={classes.pricingSection}>
      <CardHeaderComp selectionModeChanged={selectionModeChanged} seatingSelectionMode={seatingSelectionMode} />
      {updateListingsLoading ? (
        <CardContent className={classes.cardContentRoot} />
      ) : (
        <CardContent className={classes.cardContentRoot}>
          {venueImages ? (
            <VenueMap
              // {...venueImages}
              mapSectionClickCallback={mapSectionClicked}
              // currCompSections={currTNCompSections}
              seatingSelectionMode={seatingSelectionMode}
              config={marketplaceConfig}
              isCompAll={isCompAllGroup}
              activeMarketplace={activeMarketplace}
              // zones={zones[activeMarketplace]}
            />
          ) : (
            <div>No venue map available</div>
          )}
          <Grid container spacing={8} data-testid="check-zones-table">
            {zones &&
              zones[activeMarketplace] &&
              zones[activeMarketplace].map(zone => (
                <Grid item xs={zonesColumnSize} key={zone.name} data-testid="select-zones-check">
                  <Paper square style={{ maxHeight: '200px', overflowY: 'scroll' }}>
                    <Table data-testid="seating-table">
                      <TableHead>
                        <TableRow hover key={zone.name} onClick={handleCompZoneChange(zone.name)}>
                          <TableCell padding="checkbox">
                            {checkAllBox({ zone, currTNCompSections, focusedPricingGroup })}
                          </TableCell>
                          <TableCell>{zone.name || 'Unmapped'}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {zone.sections.map(section => (
                          <TableRow
                            hover
                            key={section.canonical_name}
                            onClick={handleCompSectionChange({
                              zone_name: zone.name,
                              section_name: section.name,
                            })}
                            role="checkbox"
                            tabIndex={-1}
                            selected={handleCheckboxChange({
                              zone_name: zone.name,
                              section_name: section.name,
                            })}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={handleCheckboxChange({
                                  zone_name: zone.name,
                                  section_name: section.name,
                                })}
                                color="primary"
                                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                disabled={!focusedPricingGroup || isCompAllGroup}
                              />
                            </TableCell>
                            <TableCell>
                              <Typography>{section.name}</Typography>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
              ))}
          </Grid>
        </CardContent>
      )}
    </Card>
  );
}

Seating.propTypes = {
  zones: PropTypes.array.isRequired,
  focusedPricingGroup: PropTypes.number,
  pricingActions: PropTypes.object.isRequired,
  groupsActions: PropTypes.object.isRequired,
  venueImages: PropTypes.object.isRequired,
  updateListingsLoading: PropTypes.number.isRequired,
  activeMarketplace: PropTypes.string.isRequired,
  isCompAllGroup: PropTypes.bool.isRequired,
  isCompAllEvent: PropTypes.bool.isRequired,
  currTNCompSections: PropTypes.object.isRequired,
  groupsMarketplaceComps: PropTypes.object.isRequired,
};

Seating.defaultProps = {
  focusedPricingGroup: null,
};

function mapStateToProps(state) {
  return {
    focusedPricingGroup: state.pricing.ui.focusedPricingGroup,
    zones: state.zones,
    venueImages: state.venues.venueData,
    activeMarketplace: state.globals.activeMarketplace,
    initialGroups: state.refreshGroups.initialGroups,
    isCompAllEvent: state.groupsStubhubSeatingState.isCompAllEvent,
    isCompAllGroup: state.groupsStubhubState.isCompAllGroup,
    currTNCompSections: state.pricing.currTNComparisonSections,
    groupsMarketplaceComps: state.refreshGroups.groupsMarketplaceComps,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pricingActions: bindActionCreators(pricingActionsImport, dispatch),
    groupsActions: bindActionCreators(groupsActionsImport, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Seating);
